import { Lazy } from '@betgames/bg-state-manager';
import { httpClientRepository } from '@bg-shared/infrastructure/HttpClient';
import { webSocketsRepository } from '@bg-shared/infrastructure/WebSockets';
import { sessionStore } from '@bg-shared/business/Session';
import PromotionsStore from './Promotions.store';
import PromotionsApi from './Promotions.api';

export const promotions = new Lazy(() => {
    const promotionsRepository = new PromotionsApi(httpClientRepository, webSocketsRepository);
    return new PromotionsStore(promotionsRepository, sessionStore);
});

export { promotionsSelectors } from './promotions.selectors';
export * from './interfaces';
